/**
 * Formats a number to a culture code locale (i.e. 1234 => '1,234')
 *
 * @param {number} num - The number to be formatted
 * @param {string} [locale=navigator.language] - Culture-code for formatting the number, such as 'en-US'
 * @returns {string} The formatted number
 */
export const formatNumber = (num, locale = navigator.language) => {
  return new Intl.NumberFormat(locale).format(num)
}
